import {
  getGridDateOperators,
  getGridNumericOperators,
  getGridSingleSelectOperators,
  getGridStringOperators,
} from '@mui/x-data-grid';

/**
 * Restricts a singleSelect column to the operators the backend can actually
 * satisfy: `is`/`isAnyOf` both serialize to the comma-joined value a
 * CharInFilter(lookup_expr="in") expects (see filterParams.ts). `not` has no
 * backend equivalent and is dropped rather than offered as a UI option that
 * silently does nothing.
 */
export const singleSelectFilterOperators = () =>
  getGridSingleSelectOperators().filter((op) => op.value === 'is' || op.value === 'isAnyOf');

/**
 * Restricts a date/dateTime column to the operators the backend declares as
 * `{field}_gte`/`{field}_lte` range filters - the only date filtering
 * convention this codebase's FilterSets support. `is`/`not`/`after`/`before`
 * have no matching backend param and are dropped rather than offered as UI
 * options that silently do nothing.
 */
export const dateRangeFilterOperators = () =>
  getGridDateOperators().filter((op) => op.value === 'onOrAfter' || op.value === 'onOrBefore');

/**
 * For a date/dateTime column backed by an exact-match backend DateFilter
 * (no _gte/_lte pair declared). Only `is` maps to the bare `field=value`
 * param crud.ts sends for it.
 */
export const exactDateFilterOperators = () =>
  getGridDateOperators().filter((op) => op.value === 'is');

/**
 * For a string column backed by an icontains CharFilter. Only `contains`
 * matches that lookup; `doesNotContain`/`equals`/`doesNotEqual`/`startsWith`/
 * `endsWith`/`isEmpty`/`isNotEmpty`/`isAnyOf` have no backend equivalent here.
 */
export const containsStringFilterOperators = () =>
  getGridStringOperators().filter((op) => op.value === 'contains');

/**
 * For a string column backed by an exact-match CharFilter (e.g. an id-like
 * code: NIP, serial, ksef number). Only `equals` maps to the bare
 * `field=value` param crud.ts sends for it.
 */
export const equalsStringFilterOperators = () =>
  getGridStringOperators().filter((op) => op.value === 'equals');

/**
 * For a number column backed by an exact-match NumberFilter. Only `=` maps
 * to the bare `field=value` param crud.ts sends for it - `!=`/`>`/`>=`/`<`/
 * `<=`/`isEmpty`/`isNotEmpty`/`isAnyOf` have no backend equivalent here.
 */
export const equalsNumberFilterOperators = () =>
  getGridNumericOperators().filter((op) => op.value === '=');
